export const config = {
  getMyCollege: "https://api.getmycolleges.com",
  slimAPI: "https://bulk-upload-prod.getmycolleges.com",
  cookieName: "clg_user",
  sessionCookie: "clg_sess",
};
